import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29580d34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-edit-mobile-page-section" }
const _hoisted_2 = { class: "modal-dialog-right" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_Otp = _resolveComponent("Otp")
  const _component_Dopa = _resolveComponent("Dopa")
  const _component_NewMobile = _resolveComponent("NewMobile")
  const _component_CustomerList = _resolveComponent("CustomerList")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['modal-edit-mobile-page', 'show', {hide: _ctx.isModalClose}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "arrow",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.isStep)
              ? (_openBlock(), _createBlock(_component_SelectOption, {
                  key: 0,
                  mobileNumber: _ctx.customerProfileModel.phone_number
                }, null, 8, ["mobileNumber"]))
              : _createCommentVNode("", true),
            (_ctx.isStep === _ctx.step.otp)
              ? (_openBlock(), _createBlock(_component_Otp, {
                  key: 1,
                  mobileNumber: _ctx.customerProfileModel.phone_number,
                  getCustomerProfileFn: _ctx.getCustomerProfileFn
                }, null, 8, ["mobileNumber", "getCustomerProfileFn"]))
              : _createCommentVNode("", true),
            (_ctx.isStep === _ctx.step.dopa)
              ? (_openBlock(), _createBlock(_component_Dopa, {
                  key: 2,
                  customerProfileModel: _ctx.customerProfileModel
                }, null, 8, ["customerProfileModel"]))
              : _createCommentVNode("", true),
            (_ctx.isStep === _ctx.step.newMobile)
              ? (_openBlock(), _createBlock(_component_NewMobile, {
                  key: 3,
                  mobileNumber: _ctx.customerProfileModel.phone_number
                }, null, 8, ["mobileNumber"]))
              : _createCommentVNode("", true),
            (_ctx.isStep === _ctx.step.customerList)
              ? (_openBlock(), _createBlock(_component_CustomerList, {
                  key: 4,
                  getCustomerProfileFn: _ctx.getCustomerProfileFn
                }, null, 8, ["getCustomerProfileFn"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2)
  ]))
}